import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';
import { NumberKMPipe } from '../../../../pipes/numberKMPipe';

@Component({
  selector: 'app-contactable-consent',
  templateUrl: './contactable-consent.component.html',
  styleUrls: ['./contactable-consent.component.css']
})

// Pagina 11
export class ContactableConsentComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public translations: any;
  public storeError = false;
  public selectOneError: string;
  public consentKCustomersChart: LoyaltyChart;
  public trendChart: LoyaltyChart;
  public data: QFilterModel;
  public datatable: Array<any>;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) {
  }

  ngOnInit() {
    this.translations = {};

    this.translate.get([
      'contactable.consentKCustomers',
      'contactable.contactableTrend',
      'contactable.description',
      'contactable.contactable',
      'contactable.profiling',
      'contactable.sum',
      'contactable.searchInDescription',
      'contactable.chartXTitle',
      'contactable.chartYTitle',
      'store.selectOneErrorMsg'
    ]).subscribe((t) => {
      this.translations = {
        consentKCustomers: t['contactable.consentKCustomers'],
        contactableTrend: t['contactable.contactableTrend'],
        description: t['contactable.description'],
        contactable: t['contactable.contactable'],
        profiling: t['contactable.profiling'],
        sum: t['contactable.sum'],
        searchInDescription: t['contactable.searchInDescription'],
        chart_y_title: t['contactable.chartYTitle'],
        chart_x_title: t['contactable.chartXTitle']
      };
      this.selectOneError = t['store.selectOneErrorMsg'];

      this.initChart();
    });
  }

  initChart() {
    this.consentKCustomersChart = new LoyaltyChart('heatmap');
    this.consentKCustomersChart.options.colorAxis = {minColor: '#FFFFFF', maxColor: '#77CCFF'};
    this.consentKCustomersChart.options.series = [];
    this.consentKCustomersChart.options.series.push ( {borderWidth: 1, dataLabels: { enabled: true, color: '#000'} } );
    this.consentKCustomersChart.options.series[0].dataLabels.formatter = function() {
      return NumberKMPipe.formatDynamic(this.point.value)
    };

    this.consentKCustomersChart.options.legend = {enabled: false};
    this.consentKCustomersChart.options.xAxis.title = { text : this.translations.chart_x_title };
    this.consentKCustomersChart.options.yAxis.title = { text : this.translations.chart_y_title };
    this.consentKCustomersChart.options.tooltip = {
      formatter: function() {
        let html = '';

        html += '(' + (this.point.x === 0 ? 'N' : 'S');
        html += ', ';
        html += (this.point.y === 0 ? 'N' : 'S') + ')';
        html += ': ';
        html += '<b>' + NumberKMPipe.formatDynamic(this.point.value) + '</b>';

        return html;
      }
    };

    this.trendChart = new LoyaltyChart('line');
    this.trendChart.options.legend = {layout: 'horizontal', align: 'center', verticalAlign: 'bottom'};
    this.trendChart.options.chart.zoomType = 'xy';
  }


  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValue(data: QFilterModel) {
    this.data = data;
    this.translate.get([
      'indicator.iscritti_loyalty',
      'indicator.raggiungibilita_clienti',
      'indicator.clienti_profilabili',
      'indicator.clienti_target'
    ]).subscribe(t => {
      this.indicators = [];

      this.indicatorService.indicatorCalculation('Q037', this.data).subscribe(
        res => {

          this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'iscritti_loyalty')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'raggiungibilita_clienti')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'clienti_profilabili')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, t));
          this.indicators.push(new IndicatorBoxModel([res.find(r => r.name === 'clienti_target')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}, t));

        });
    });

    this.consentKCustomersInit(data);
    this.trendInit(data);
    this.tableInit (data);
    this.show_results = true;
  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  public consentKCustomersInit(data: QFilterModel) {

    this.indicatorService.getChart('customers.Q131', data, false).subscribe( res => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let serie2 = res.series[2].serie;

      const xAxis = {
        serie: serie0.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })
      };

      const yAxis = {
        serie: serie1.filter(function (value, index, self) {
          return self.indexOf(value) === index;
        })
      };

      let series: Array<any> = [];
      for (let i = 0; i < serie2.length; i++) {
        series.push([ xAxis.serie.indexOf (serie0[i]), yAxis.serie.indexOf (serie1[i]), serie2[i] ]);
      }

      if (this.consentKCustomersChart.instance) {
        while (this.consentKCustomersChart.instance.series.length > 0) {
          this.consentKCustomersChart.instance.series[0].remove(true);
        }
      }

      this.consentKCustomersChart.options.xAxis.categories = xAxis.serie;
      this.consentKCustomersChart.options.yAxis.categories = yAxis.serie;
      this.consentKCustomersChart.options.series[0].data = series;

      for (let i = 0; i < series.length; i++) {

        this.consentKCustomersChart.instance.addSeries(series[i]);
      }

      this.consentKCustomersChart.instance.update(this.consentKCustomersChart.options);
      this.consentKCustomersChart.instance.redraw();
    });
  }

  public trendInit(data: QFilterModel) {
    this.chartsService.loadChart(this.trendChart, 'customers.Q132', data, this.indicatorService, this.translate);
  }

  public tableInit (data: QFilterModel) {
    this.indicatorService.getChart('customers.Q133', data).subscribe((resp) => {

      this.datatable = [];
      let serie0 = resp.series[0].serie;
      let serie1 = resp.series[1].serie;
      let serie2 = resp.series[2].serie;
      for (let i = 0; i < serie0.length; i++) {
        this.datatable.push ( { index: i,
          desc: serie0[i],
          cont: serie1[i] + '%',
          prof: serie2[i] + '%'} );
      }

    });
  }

  resetData() {
    this.show_results = false;
  }

  applayFilter (str: string) {
    for (let i = 0; i < this.datatable.length; i++) {
      if (this.datatable[i].desc.toLowerCase ().indexOf (str.toLowerCase ()) >= 0) {
        document.getElementById ('index-' + this.datatable[i].index).style.display = 'table-row';
      } else {
        document.getElementById ('index-' + this.datatable[i].index).style.display = 'none';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-contactable/contactable-consent/contactable-consent.component.ts